import { Injectable } from '@angular/core';
@Injectable({
	providedIn: 'root'
})
export class ButtonService {

	constructor() { }

	SetupFAIconButton(
		button: HTMLButtonElement,
		span: HTMLSpanElement,
		title: string,
		iconClass: string,
		size: string = 'sm',
		mode: string = 'primary',
		solid = 'false',
		regular = 'false',
		toggleable = 'false',
		hidden = 'false',
		menu: string = null) {
		button.setAttribute('title', title);
		button.setAttribute('data-menu', menu);
		button.className += 'btn btn-' + size + ' btn-' + mode;
		if (menu !== '') {
			$('.' + menu).toggleClass('hidden', true);
		}
		if (!!iconClass) {
			if (iconClass.substr(0, 3) === 'far') {
				span.className += iconClass;
			} else if (iconClass.substr(0, 3) !== 'sl-') {
				span.className = 'fa';

				if (solid === 'true') {
					span.className += 's fa-' + iconClass;
				} else {
					if (regular === 'true') {
						span.className += 'r fa-' + iconClass;
					}
				}
				span.className += ' ';
				if (span.className.indexOf('fa ') > -1) {

					span.className += ' fa-' + iconClass;
				}
			} else {
				span.className += iconClass;
			}
		}
		if (['true', 'on'].indexOf(toggleable) > -1) {
			span.className += ' toggleable';
			$(button).attr('data-on-state', toggleable === 'on' ? 'on' : 'off');
			$(button).on('click', () => {
				this.ToggleButton(button);
			});
			if (toggleable === 'on') {
				this.ToggleButton(button, true);
			} else {
				this.ToggleButton(button, false);
			}

		}
		if (hidden === 'true') {
			$(button).toggleClass('hidden', true);
		}

	}
	ToggleButton(button: HTMLButtonElement, optOnOff: boolean = null) {
		/* if (optOnOff === false) {
			if ($('span:nth-child(1)', button).hasClass('toggleable') === false) {
				return;
			}
		}*/
		if (optOnOff === null) {
			optOnOff = $(button).attr('data-on-state') !== 'on';
		}

		let menu = button.hasAttribute('data-menu') ? '.' + button.attributes['data-menu'].value : '';
		if (menu === '.null') { menu = ''; }
		if (optOnOff === true) {
			$(button).toggleClass('btn-primary', false);
			$(button).toggleClass('btn-secondary ', true);
			if (menu !== '') {
				$(menu).toggleClass('hidden', false);
			}
			$(button).attr('data-on-state', 'on');
		} else {
			$(button).toggleClass('btn-primary', true);
			$(button).toggleClass('btn-secondary', false);
			if (menu !== '') {
				$(menu).toggleClass('hidden', true);
			}
			$(button).attr('data-on-state', 'off');
		}
	}
}
